"use client";
import { Highlight, Stack } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { Heading, Text } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";

export type IntroProps = {
  title?: string;
  text: string;
  highlightedText?: string | string[];
  children?: React.ReactNode;
};

const SimpleIntro = (props: IntroProps) => {
  const HeadingVariant = useHeadingVariant();
  const { title, text, highlightedText = [], children } = props;
  return (
    <Stack gap={4} maxW={"8xl"} mx={"auto"}>
      {title && (
        <Balancer>
          <Heading
            as="h2"
            variant={HeadingVariant}
            textAlign={"center"}
            whiteSpace={"pre-line"}
          >
            {title}
          </Heading>
        </Balancer>
      )}
      <Balancer>
        <Text
          px={6}
          color="text.100"
          textAlign={"center"}
          variant={"body1"}
          whiteSpace={"pre-line"}
        >
          <Highlight
            query={highlightedText}
            styles={{ fontWeight: 600, color: "text.100" }}
          >
            {text}
          </Highlight>
        </Text>
      </Balancer>
      {children && children}
    </Stack>
  );
};

export default SimpleIntro;
